export default function PHP_is_bool() {
  return (
    <div>
      <h1>PHP_is_bool</h1>
    </div>
  );
}
